'use client';

import { pubsubPublishPostHogEvent } from '@/actions/services/posthog/actions';
import { PostHogEventPayloadType } from '@/types/posthog.types';

import { useStore } from '@/stores';
import { sendGTMEvent } from '@next/third-parties/google';
import { PublishThirdPartyService } from '@/types/pubsub.types';
import posthog from 'posthog-js';

/**
 * Custom hook to track events in Google Tag Manager.
 * @returns {object} trackEvent - Function to track events.
 */
function useStriqueAnalytics() {
  const user = useStore((state) => state.user);
  const currentStore = useStore((state) => state.currentStore);

  const trackEvent = (eventName: string, eventProperties?: object) => {
    console.log('[trackEvent]', eventName, eventProperties);
    sendGTMEvent({
      event: eventName,
      ...(user?.email ? { email_address: user?.email } : null),
      ...(currentStore?.striqueStore?.name ? { org_name: currentStore?.striqueStore.name } : null),
      ...(eventProperties ? { ...eventProperties } : null)
    });
  };

  const trackPostHogEvent = async (event: PostHogEventPayloadType) => {
    const sessionId = posthog.get_session_id() || '';
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

    await pubsubPublishPostHogEvent({
      service: PublishThirdPartyService.POSTHOG,
      payload: {
        ...event,
        ...(user?.id ? { distinctId: event.distinctId || user?.id } : null),
        properties: {
          ...event.properties,
          ...(user?.email ? { user_email: user?.email } : null),
          ...(currentStore?.striqueStore?.id ? { org_id: currentStore?.striqueStore.id } : null),
          ...(currentStore?.striqueStore?.name
            ? { org_name: currentStore?.striqueStore.name }
            : null),
          ...(currentStore?.striqueStore?.name || currentStore?.striqueStore?.website
            ? {
                $set: {
                  ...(currentStore?.striqueStore?.name
                    ? { org_name: currentStore?.striqueStore.name }
                    : null),
                  ...(currentStore?.striqueStore?.website
                    ? { website: currentStore?.striqueStore.website }
                    : null)
                }
              }
            : null),
          ...(currentStore?.striqueStore?.website
            ? { website_url: currentStore?.striqueStore.website }
            : null),
          $session_id: sessionId,
          $current_url: currentUrl
        }
      }
    });
  };

  return { trackEvent, trackPostHogEvent };
}

export { useStriqueAnalytics };
